import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Link } from "@material-ui/core";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";
import ContactView from "../../views/account/ContactView";
import ProfileView from "../../views/account/ProfileView";
import AddressView from "../../views/account/AddressView";
import AccountView from "../../views/account/AccountView";
import Check from "../../components/Check";

const RegisterInstallerForm = ({ initialValues, onSubmit = () => {} }) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required(t("register.errors.required")),
    last_name: Yup.string().required(t("register.errors.required")),
    email: Yup.string()
      .email(t("register.errors.invalid_email"))
      .required(t("register.errors.required")),
    username: Yup.string().required(t("register.errors.required")),
    password: Yup.string().required(t("register.errors.required")),
    confirm_password: Yup.string().required(t("register.errors.required")),
    telephone_number: Yup.string(),
    cellular_number: Yup.string().required(t("register.errors.required")),
    street: Yup.string().required(t("register.errors.required")),
    city: Yup.string().required(t("register.errors.required")),
    district: Yup.string().required(t("register.errors.required")),
    cap: Yup.string().required(t("register.errors.required")),
    country: Yup.string().required(t("register.errors.required")),
    vat_number: Yup.string().required(t("register.errors.required")),
    terms_and_conditions: Yup.boolean().oneOf(
      [true],
      t("register.errors.required"),
    ),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <ProfileView {...props} />
          </Box>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <AccountView {...props} />
          </Box>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <ContactView {...props} installer={true} />
          </Box>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <AddressView {...props} />
          </Box>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <Check
              {...props}
              name="terms_and_conditions"
              label={
                <Link
                  href={t("register.terms_and_conditions_link")}
                  color="textSecondary"
                  rel="noreferrer"
                  target="_blank"
                >
                  {t("register.terms_and_conditions")}
                </Link>
              }
            />
          </Box>

          <Box mt={2} display="flex" justifyContent="flex-start">
            <Submit {...props} title={t("register.button")} />
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default RegisterInstallerForm;
